<main class="auth-page min-vh-100 bg-white text-dark">
  <div class="row g-0 min-vh-100">
    <section class="col-lg-6 auth-brand-panel text-white p-4 p-lg-4 d-none d-lg-flex flex-column justify-content-between overflow-hidden position-relative bg-dark">
      <router-link to="/" class="auth-brand-mark d-inline-flex mb-3 align-self-start bg-white rounded-3 p-2" aria-label="Siyanda Platinum home">
        <span class="auth-brand-mark-img d-block" role="img" aria-label="Siyanda Bakgatla Platinum Mine"></span>
      </router-link>

      <div>
        <p class="text-uppercase text-warning fw-bold text-xxs mb-2">Siyanda Bakgatla Platinum Mine</p>
        <h1 class="h3 fw-bold mb-2">Mining operations data, ready when you are.</h1>
        <p class="text-white-50 mb-0">
          Sign in to access operational performance, safety, sustainability, and production insights.
        </p>
      </div>

      <div>
        <hr class="my-3" />
        <div class="row g-3">
          <div class="col-4">
            <span class="d-block text-uppercase text-white-50 text-xxs mb-1">Production</span>
            <span class="d-block fw-bold text-warning">Tracked daily</span>
          </div>
          <div class="col-4">
            <span class="d-block text-uppercase text-white-50 text-xxs mb-1">Safety</span>
            <span class="d-block fw-bold text-warning">Always on</span>
          </div>
          <div class="col-4">
            <span class="d-block text-uppercase text-white-50 text-xxs mb-1">Sustainability</span>
            <span class="d-block fw-bold text-warning">Community first</span>
          </div>
        </div>
      </div>
    </section>

    <section class="col-lg-6 bg-white text-dark d-flex align-items-center justify-content-center p-4 p-md-5">
      <div class="col-12 col-sm-10 col-md-8 col-lg-9 col-xl-7">
        <h2 class="h3 fw-bold mb-2">Welcome back</h2>
        <p class="text-secondary mb-4">Enter your Siyanda Platinum Platform details to continue.</p>

        <SnackbarMessage
          :error-message="error_message"
          :success-message="success_message"
          @dismiss-error="error_message = ''"
          @dismiss-success="success_message = ''"
        />

        <div v-if="is_loading" class="text-center mb-3">
          <div class="spinner-border spinner-border-sm me-2 text-primary"></div>
          <span class="text-secondary">Authenticating...</span>
        </div>

        <form v-if="!is_loading" @submit.prevent="handle_login">
          <div class="mb-3">
            <label class="form-label fw-bold text-xs" for="login-email">Email address</label>
            <input
              id="login-email"
              v-model="credentials.email"
              type="email"
              class="form-control"
              placeholder="name@siyandaplatinum.com"
              autocomplete="email"
              required
            />
          </div>

          <div class="mb-4">
            <label class="form-label fw-bold text-xs" for="login-password">Password</label>
            <div class="position-relative">
              <input
                id="login-password"
                v-model="credentials.password"
                :type="password_input_type"
                class="form-control pe-5"
                placeholder="Enter your password"
                autocomplete="current-password"
                required
              />
              <button
                type="button"
                class="btn position-absolute top-50 end-0 translate-middle-y px-3"
                @click="toggle_change_password_type"
                :aria-label="password_input_type === 'password' ? 'Show password' : 'Hide password'"
              >
                <i :class="password_input_type === 'password' ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
              </button>
            </div>
          </div>

          <button class="btn btn-primary w-100 py-2 mb-3" :disabled="is_loading">
            Sign in
          </button>

          <p class="text-center text-secondary small mb-0">
            Forgot your password?
            <router-link to="/reset_password" class="fw-semibold text-primary">
              Reset
            </router-link>
          </p>
        </form>
      </div>
    </section>
  </div>
</main>
